import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';

// Targeta d'acció ràpida del dashboard (Home); mostra icona, títol i descripció i navega a `to` en clicar.
const QuickActionCard = ({ title, description, icon: Icon, to, color = "primary" }) => {

    // Map colors
    const getBgColor = (c) => {
        switch (c) {
            case 'primary': return 'var(--ab-primary)';
            case 'warning': return 'var(--ab-warning)'; // For Electricidad (often Yellow/Orange)
            case 'danger': return 'var(--ab-error)'; // For Gas (often Red/Orange)
            case 'success': return 'var(--ab-primary-light)';
            default: return 'var(--ab-primary)';
        }
    };

    const background = getBgColor(color);

    return (
        <Link to={to} className="text-decoration-none h-100 d-block">
            <Card className="h-100 border-0 shadow rounded-4 hover-elevate transition-all overflow-hidden">
                <Card.Body className="p-4 text-center d-flex flex-column align-items-center justify-content-center">
                    <div
                        className="mb-3 d-flex align-items-center justify-content-center rounded-circle text-white shadow-sm"
                        style={{
                            width: '70px',
                            height: '70px',
                            fontSize: '1.8rem',
                            background: background
                        }}
                    >
                        <Icon />
                    </div>
                    <h5 className="fw-bold mb-2 text-dark">{title}</h5>
                    <p className="text-muted small mb-0">{description}</p>
                </Card.Body>
            </Card>
        </Link>
    );
};

export default QuickActionCard;
